<div class="dialog-box card">
  <div class="card-header">
    Change Schedule

    <span class="float-end" (click)="onCloseDialogue()">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>
  @if (!hasJobStarted) {
    <div class="form-floating mb-3">
      <input
        type="datetime-local"
        class="form-control"
        placeholder="Start Time"
        [(ngModel)]="startDateTime"
        [min]="validStartDate"
        [class.is-invalid]="schedulerForm.controls['start_day'].invalid"
        (input)="changeShiftDateTime(0, $event)"
        (change)="changeShiftDateTime(0, $event)"
      />
      <label>Start Time</label>
    </div>
  }
  <div class="form-floating mb-3">
    <input
      type="datetime-local"
      class="form-control"
      placeholder="End Time"
      [(ngModel)]="endDateTime"
      [min]="validStartDate"
      [class.is-invalid]="schedulerForm.controls['end_day'].invalid"
      (input)="changeShiftDateTime(1, $event)"
      (change)="changeShiftDateTime(1, $event)"
    />
    <label>End Time</label>
  </div>
  @if (errorMessage && !schedulerForm.valid) {
    <div class="alert alert-danger alert-dismissible fade show" role="alert">
      {{ errorMessage }}
    </div>
  } @else {
    <div class="fs-5 alert px-4" id="repeat-description">
      {{ schedulerForm.value | misc: "shiftSummary" : true }}
      @if (schedulerForm.value | misc: "getTimeDifference") {
        [Duration:
        {{ schedulerForm.value | misc: "getTimeDifference" }} Hrs]
      }
    </div>
  }

  <div class="row row-cols-2 mt-4">
    <div class="col">
      <button class="btn btn-lg w-100 btn-dark" (click)="onCloseDialogue()">
        Cancel
      </button>
    </div>

    <div class="col">
      <button
        class="btn btn-primary btn-lg w-100"
        [disabled]="disableShiftUpdate"
        (click)="onCloseDialogue(schedulerForm.value)"
      >
        Update
      </button>
    </div>
  </div>
</div>
